(() => {
  if (window.conneeProductCarouselInitialized) return;

  window.conneeProductCarouselInitialized = true;

  class ConneeProductCarousel {
    constructor(carousel) {
      this.carousel = carousel;
      this.slides = Array.from(
        carousel.querySelectorAll("[data-connee-slide]")
      );

      this.dots = Array.from(
        carousel.querySelectorAll("[data-connee-carousel-dot]")
      );

      this.previousButton = carousel.querySelector(
        "[data-connee-carousel-previous]"
      );

      this.nextButton = carousel.querySelector(
        "[data-connee-carousel-next]"
      );

      this.currentIndex = 0;
      this.touchStartX = 0;
      this.touchEndX = 0;

      if (this.slides.length <= 1) return;

      this.bindEvents();
      this.showSlide(0);
    }

    bindEvents() {
      this.previousButton?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.showPreviousSlide();
      });

      this.nextButton?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.showNextSlide();
      });

      this.dots.forEach((dot) => {
        dot.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();

          const index = Number(dot.dataset.slideIndex);

          if (Number.isInteger(index)) {
            this.showSlide(index);
          }
        });
      });

      this.carousel.addEventListener(
        "touchstart",
        (event) => {
          this.touchStartX = event.changedTouches[0].clientX;
        },
        { passive: true }
      );

      this.carousel.addEventListener(
        "touchend",
        (event) => {
          this.touchEndX = event.changedTouches[0].clientX;
          this.handleSwipe();
        },
        { passive: true }
      );

      this.carousel.addEventListener("keydown", (event) => {
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          this.showPreviousSlide();
        }

        if (event.key === "ArrowRight") {
          event.preventDefault();
          this.showNextSlide();
        }
      });
    }

    showPreviousSlide() {
      const newIndex =
        this.currentIndex === 0
          ? this.slides.length - 1
          : this.currentIndex - 1;

      this.showSlide(newIndex);
    }

    showNextSlide() {
      const newIndex =
        this.currentIndex === this.slides.length - 1
          ? 0
          : this.currentIndex + 1;

      this.showSlide(newIndex);
    }

    showSlide(index) {
      if (!this.slides[index]) return;

      this.currentIndex = index;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === index;
        const imageLink = slide.querySelector("a");

        slide.classList.toggle("is-active", isActive);
        slide.setAttribute("aria-hidden", String(!isActive));

        if (imageLink) {
          imageLink.setAttribute("tabindex", isActive ? "0" : "-1");
        }
      });

      this.dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;

        dot.classList.toggle("is-active", isActive);
        dot.setAttribute("aria-current", String(isActive));
      });
    }

    handleSwipe() {
      const swipeDistance = this.touchEndX - this.touchStartX;
      const minimumSwipeDistance = 45;

      if (Math.abs(swipeDistance) < minimumSwipeDistance) return;

      if (swipeDistance > 0) {
        this.showPreviousSlide();
      } else {
        this.showNextSlide();
      }
    }
  }

  const initializeConneeCarousels = (container = document) => {
    const carousels = container.querySelectorAll(
      "[data-connee-carousel]:not([data-carousel-initialized])"
    );

    carousels.forEach((carousel) => {
      carousel.setAttribute("data-carousel-initialized", "true");
      new ConneeProductCarousel(carousel);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializeConneeCarousels();
    });
  } else {
    initializeConneeCarousels();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeConneeCarousels(event.target);
  });

  document.addEventListener("shopify:section:reorder", () => {
    initializeConneeCarousels();
  });
})();